import * as React from "react";
import PropTypes from "prop-types";

import { AbsoluteModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { reject } from "../../../../../../Common/TypingUtils";

const InstanceIndexContext = React.createContext<number | undefined>(undefined);

export const instanceIndexContextTypes = {
    // Этот контекст используется в кастомных контролах в candy.farm для отображения пронумерованных строк.
    candy_dangerous_InstanceIndex: PropTypes.number,
};

interface ProvideInstanceIndexContext {
    candy_dangerous_InstanceIndex: number;
}

interface ProvideInstanceIndexProps {
    // BindingPath тут нужен для того, чтобы при вызове явно привязать множественность к пути. Не надо его убирать
    bindingPath: AbsoluteModelPath;
    index: number;
    children: React.ReactElement;
}

export function useInstanceIndex(): number {
    return React.useContext(InstanceIndexContext) ?? reject("Parents does not contain ProvideInstanceIndex calls.");
}

export class ProvideInstanceIndex extends React.Component<ProvideInstanceIndexProps> {
    public static childContextTypes = instanceIndexContextTypes;

    public getChildContext(): ProvideInstanceIndexContext {
        return {
            candy_dangerous_InstanceIndex: this.props.index,
        };
    }

    public render(): null | JSX.Element {
        return (
            <InstanceIndexContext.Provider value={this.props.index}>
                {this.props.children}
            </InstanceIndexContext.Provider>
        );
    }
}
